var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTableSolid = function SvgTableSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5v22h22V5Zm2 2h5v5H7Zm7 0h4v5h-4Zm6 0h5v5h-5ZM7 14h5v4H7Zm7 0h4v4h-4Zm6 0h5v4h-5ZM7 20h5v5H7Zm7 0h4v5h-4Zm6 0h5v5h-5Z"
  })));
};
export default SvgTableSolid;